import {
  appList,
  helplineAreas,
  sliderImageList,
} from '@/constants/farmerHelpline'
import STRINGS from '@/constants/strings'

import Carousel from '../carousel'
import DownloadApps from '../downloadApps'
import Picture from '../picture'

const farmerHelplineAssetDir = '/assets/images/farmer-helpline'

export default function FarmerHelpline() {
  return (
    <>
      <section className="max-w-7xl m-auto">
        <div className="pb-8 px-4">
          <h1 className="font-natosans-regular text-black text-3xl md:text-5xl mt-5 mb-2">
            {STRINGS.FARMER_HELPLINE.SECTION_1_HEADING}
          </h1>
          <h5 className="text-[#6bb51e] text-xl md:text-3xl font-natosans font-normal">
            {STRINGS.FARMER_HELPLINE.SECTION_1_SUB_HEADING}
          </h5>
        </div>
        <div className="pb-12 flex flex-col md:flex-row flex-nowrap">
          <div className="relative px-4 w-full md:w-2/3">
            <div className="text-[#646464] font-natosans-light">
              <h2 className="font-natosans-medium  py-2 text-5xl">
                <a
                  href={`tel:${STRINGS.FARMER_HELPLINE.CONTACT}`}
                  className="text-[#6bb51e]"
                >
                  {STRINGS.FARMER_HELPLINE.CONTACT}
                </a>
              </h2>
              <p>
                {STRINGS.FARMER_HELPLINE.SECTION_1_DESCRIPTION_TEXT_1}
                <br />
                <br />
                {STRINGS.FARMER_HELPLINE.SECTION_1_DESCRIPTION_TEXT_2}
              </p>
            </div>
          </div>
          <Picture
            image={`${farmerHelplineAssetDir}/advisory`}
            imageAlt="Dehaat Testimonial"
            imageStyle="w-full m-auto p-4 md:min-w-[200px]"
            pictureStyle="px-0 md:px-4 w-full md:w-[33%]"
          />
        </div>
      </section>
      <section className="px-4 max-w-7xl m-auto">
        <div className="pt-12 flex flex-wrap flex-row">
          <div className="w-full md:w-1/5 px-6 py-10 bg-[#6bb51e] relative">
            <h5 className="text-white font-natosans-regular text-sm md:text-base my-3 text-center md:text-left">
              {STRINGS.FARMER_HELPLINE.SECTION_2_HEADING}
            </h5>
            <div className="absolute w-8 h-8 rotate-45 bg-[#6bb51e] -bottom-4 right-[46%] md:top-[44%] md:-right-4"></div>
          </div>
          {helplineAreas.map(({ imageUrl, label }) => (
            <div
              key={label}
              className="w-full md:w-1/5 flex-col flex px-6 py-10 border-b border-x md:border-y md:border-r border-[#ECECEC] md:items-start items-center"
            >
              <Picture image={imageUrl} imageAlt={label} imageStyle="w-16" />
              <div className="w-fit mt-4">
                <h5 className="text-base font-natosans-regular">{label}</h5>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-7xl m-auto">
        <div className="pb-12 flex flex-col md:flex-row flex-nowrap">
          <div className="relative px-4 w-full md:w-2/3">
            <h6 className="font-natosans-medium text-black text-2xl md:text-3xl pt-12 mt-5 mb-2">
              {STRINGS.FARMER_HELPLINE.SECTION_3_HEADING}
            </h6>
            <div className="text-[#646464] font-natosans-light pt-6">
              {STRINGS.FARMER_HELPLINE.SECTION_3_DESCRIPTION_TEXT}
            </div>
            <DownloadApps apps={appList} />
          </div>
          <Picture
            image={`${farmerHelplineAssetDir}/Lab`}
            imageAlt="Dehaat Testimonial"
            imageStyle="m-auto w-full pt-12 md:min-w-[200px]"
            pictureStyle="px-4 w-full md:w-1/3"
          />
        </div>
      </section>
      <section className="py-5 wow slideInUp overflow-hidden max-w-7xl m-auto">
        {sliderImageList && (
          <Carousel
            imageList={sliderImageList}
            aspectRatio={4 / 3}
            desktopImageCount={3}
            mobileImageCount={1}
          />
        )}
      </section>
    </>
  )
}
